import { useQuery } from '@tanstack/react-query';
import { createFileRoute, useParams } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { ErrorBoundary } from '@/components/ErrorBoundary';
import Table from '@/components/Table';
import { useFleetAccount } from '@/contexts/fleet-account/useFleetAccount';
import { getAllFleetUnitsQueryOptions, getLatestActiveStateQueryOptions } from '@/service/vpc/queryOptions';
import useFaultCodesTable from '@/tables/useFaultCodesTable';
import { chassis } from '@/utils';

export const Route = createFileRoute('/_authenticated/_account/fleets/$fleetId/dashboard/active-fault-codes/')({
  component: ActiveFaultCodesPage,
  errorComponent: ErrorBoundary,
});

function ActiveFaultCodesPage() {
  const { fleetId } = useParams({
    from: '/_authenticated/_account/fleets/$fleetId/dashboard/active-fault-codes/',
  });
  const { t } = useTranslation();
  const { isLoading: isFleetUnitsLoading, fleetVerifiedUnits } = useFleetAccount();

  const { data: fleetUnits, isLoading: isfleetUnitsLoading } = useQuery(getAllFleetUnitsQueryOptions({ fleetId }));

  const unitIds = fleetUnits?.items.map((unit) => Number(unit.endCustomerUnitId));
  const filteredUnits = fleetVerifiedUnits?.filter((unit) => unitIds?.includes(unit.endCustomerUnitId));
  const chassisIds = chassis.extractChassisIdsCsv(filteredUnits);

  const { columns } = useFaultCodesTable(filteredUnits);

  const { data: activeFaultCodes, isLoading } = useQuery(
    getLatestActiveStateQueryOptions({ chassisIds, pageSize: 100, pageNumber: 1 })
  );

  return (
    <>
      <Table
        headerTitle={t(($) => $.pages.account.dashboard.active_fault_codes.units_title)}
        isLoading={isFleetUnitsLoading || isfleetUnitsLoading || isLoading}
        data={activeFaultCodes || []}
        columns={columns}
        showSearch={true}
      />
    </>
  );
}
